export function setCookie(key: string, value: string) {
  const now = new Date();
  now.setTime(now.getTime() + 3600000);
  const expires = `expires=${now.toUTCString()};`;
  document.cookie = `${key}=${encodeURIComponent(value)}; ${expires} path=/;`;
}

export function getCookie(key: string): string | null {
  const nameEQ = `${key}=`;
  const cookiesArray = document.cookie.split(';');
  for (let i = 0; i < cookiesArray.length; i++) {
    let c = cookiesArray[i].trim();
    if (c.indexOf(nameEQ) === 0) {
      return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
  }
  return null;
}

export function removeCookie(key: string) {
  document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}
